import React from "react";
import Loader from "react-loader-spinner";
import "./styles.sass";

export const LoadingSpinner = (props) => {
    const {
        topMessage, topMessageClassName='',
        message, messageClassName = '',
        quote, quoteClassName = '',
        loaderColor = '#FFF', loaderType = "Rings"
    } = props

    return (
        <div className="spinner">
            {topMessage ? <div className={`${topMessageClassName}`}>{topMessage}</div> : null}
            <Loader type={loaderType} height="100" width="100" color={loaderColor} />
            {quote ? <div className={`${quoteClassName}`}>{quote}</div> : null}
            {message ? <div className={`${messageClassName}`}>{message}</div> : null}
        </div>
    );
};
